module.exports = __webpack_public_path__ + "media/svg/reviews-b5be4625.svg";